(function () {
  'use strict';
  angular.module('neo.config', [])
.constant('EnvironmentConfig', {'API':'https://neo.cebllob.com/api/','whiteListedDomains':['neo.cebllob.com','neo.cebllob.com:8080','neo.cebllob.com:443']});
 
})();